import Avatar from '@pelckmans/elementis/components/avatar';
import { useContext, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import UserImagesContext from '../../../contexts/UserImagesContext';
import useClickOutside from '../../../hooks/useClickOutside';
import UserMenu from './UserMenu';

function User() {
  const [showMenu, setShowMenu] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const { avatar } = useContext(UserImagesContext);

  useClickOutside({
    ref,
    elementId: 'user-menu',
    onClickOutside: () => setShowMenu(false),
    enabled: showMenu,
  });

  const { t } = useTranslation();

  return (
    <div ref={ref}>
      <Avatar
        onClick={() => {
          setShowMenu(x => !x);
        }}
      >
        <Avatar.Image name={t('APP_NAV.SIDE_NAV.IMAGE.ALT')} src={avatar} size="lg" />
      </Avatar>
      {showMenu && <UserMenu referenceEl={ref.current} />}
    </div>
  );
}

export default User;
